// extracted by mini-css-extract-plugin
module.exports = {"container":"_2AL1IWjZpY0hbWJ-gvQZ0e","cancelBtn":"_11MSGI4VVTnn6umJt1Y18k","icon":"esUUbnTVPhkVxzcv-VsFO","saveBtn":"_2aZqnGia_OQ1UjeZREZww7"};